export function formatType(type) {
    if (type === 'affair')
        return "Affaire";
    if (type === 'contract')
        return "Contrat";

    return type;
}

export function formatInvoicingMode(invoicingMode) {
    if (invoicingMode === "in_advance")
        return "A échoir";
    else if (invoicingMode === "arrears")
        return "A terme échu";
    else if (invoicingMode === "when_inspecting")
        return "A la visite";

    return invoicingMode;
}